import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";
import React from "react";

type Props = {
  onNextClick?: () => void;
  onPrevClick?: () => void;
  onSaveClick?: () => void;
  onFinishClick?: () => void;
  onBackToLoginClick?: () => void;
};

const ContractingFooter = ({
  onNextClick,
  onPrevClick,
  onSaveClick,
  onFinishClick,
  onBackToLoginClick,
}: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "contractingFooter");

  // render
  return (
    <div className="row mx-n2 justify-content-end mt-4">
      {onBackToLoginClick && (
        <div className="col col-sm-auto px-2 mr-sm-auto">
          <button
            className="btn btn-block btn-outline-secondary px-3 py-2"
            onClick={onBackToLoginClick}
          >
            <span className="d-sm-none">{tLabels("backToLoginBtn.mobile")}</span>
            <span className="d-none d-sm-inline">{tLabels("backToLoginBtn.desktop")}</span>
          </button>
        </div>
      )}
      {onPrevClick && (
        <div className="col col-sm-auto px-2 mr-sm-auto">
          <button
            className="btn btn-block btn-secondary px-4 py-2"
            onClick={onPrevClick}
          >
            <FontAwesomeIcon icon="chevron-left" />
            <span className="ml-2">{tLabels("prevBtn")}</span>
          </button>
        </div>
      )}
      {onSaveClick && (
        <div className="col-12 col-sm-auto order-1 order-sm-0 px-2">
          <button
            className="btn btn-block btn-outline-secondary py-2 mt-3 mt-sm-0"
            onClick={onSaveClick}
          >
            <FontAwesomeIcon icon="save" />
            <span className="ml-2">{tLabels("saveBtn")}</span>
          </button>
        </div>
      )}
      {onNextClick && (
        <div className="col col-sm-auto px-2">
          <button
            className="btn btn-block btn-primary px-4 py-2"
            onClick={onNextClick}
          >
            <span className="mr-2">{tLabels("nextBtn")}</span>
            <FontAwesomeIcon icon="chevron-right" />
          </button>
        </div>
      )}
      {onFinishClick && (
        <div className="col col-sm-auto px-2">
          <button
            className="btn btn-block btn-primary px-3 py-2"
            onClick={onFinishClick}
          >
            <span className="mr-2">{tLabels("finishBtn")}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ContractingFooter;
